import type { ProductDataKeys } from '@app/pages/ProcessingResultsPageInner/ui/ProductCharacteristics/types'
import type { ProductCharacteristics } from '@app/pages/ProcessingResultsPageInner/types'

export const titlesMap: Partial<Record<keyof ProductCharacteristics, string>> = {
  trend: 'Направление',
  purchasingGroup: 'Группа закупок',
  productGroup: 'Группа товаров',
  category: 'Категория',
  subcategory: 'Подкатегория',
  brand: 'Бренд',
  manufacturer: 'Производитель',
  regionManufacturer: 'Регион производитель',
  categoryEggs: 'Категория яиц',
  shell: 'Оболочка',
  fatContentOrFortress: 'Жирность/крепость',
  packingVolume: 'Объем упаковки',
  productForm: 'Форма выпуска',
  packing: 'Упаковка',
  isRecalculation: 'Перерасчет',
  productRating: 'Рейтинг товара'
}

export const targetKeys = Object.keys(titlesMap) as ProductDataKeys[]
